import { Dispatch } from 'react';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';

import { AppStore, NonNullableAppStore } from 'src/app/store';
import defaultError from 'src/components/Notifications/DefaultError';
import { AddNotification } from 'src/components/Notifications/Provider/types';
import { PriceCart, updatePriceCart } from 'src/models/price/priceCart';
import { fetcher } from 'src/utils/fetcher';

const PRICE_DISCOUNT_URL = '/shards/price/cart/discount';

declare global {
    interface FetcherPostApi {
        [PRICE_DISCOUNT_URL]: {
            body: { discountInPercent: number; discountInAmount: number };
            queryParams: {
                employerId?: string;
            };
            response: {
                priceCart: PriceCart;
            };
        };
    }
}

const calculateDiscount =
    (discountInPercent: number, discountInAmount: number, addNotification: AddNotification) =>
    (
        dispatch: Dispatch<ThunkAction<Action | null, AppStore, unknown, Action> | Action>,
        getState: () => NonNullableAppStore
    ): Promise<void> => {
        const employerId = getState().priceData.priceEmployerId;

        return fetcher
            .post('/shards/price/cart/discount', { discountInPercent, discountInAmount }, { params: { employerId } })
            .then(
                ({ data }) => {
                    if (data.priceCart) {
                        dispatch(updatePriceCart(data.priceCart));
                        return;
                    }
                    addNotification(defaultError);
                    throw new Error('Cart discount error');
                },
                () => {
                    addNotification(defaultError);
                    throw new Error('Cart discount error');
                }
            );
    };

export default calculateDiscount;
